export const productBlockImagesSliderOptions = (instance) => {
    const container = $(instance);
    const slidesCount = container.find('.swiper-slide').length;

    return {
        slidesPerView: 1,
        slidesPerGroup: 1,
        cssMode: false,
        autoplay: slidesCount > 1 ? {
            delay: 4000,
        } : false,
        loop: slidesCount > 1,
        loopAdditionalSlides: 1,
        autoHeight: false,
        pagination: {
            el: instance.paginationEl,
            clickable: true,
            hideOnClick: false,
        },
    }
}